export default function GridCardFixer(): JSX.Element {
    return <div className="flex flex-col border border-transparent px-2 min-w-[120px] md:min-w-[200px] flex-1" />;
}
